module.exports = __webpack_public_path__ + "img/szg.92c6d7ca.jpg";